export const CodesToColorMapFunc = (code, groupTheme) => {
	if (groupTheme) {
	} else {
		return null;
	}

	const getGroupTheme = (code) => {
		switch (code) {
			case "primary":
				return groupTheme.primary();
			case "secondary":
				return groupTheme.secondary();
			case "experience":
			case "experience-hospital":
			case "experience-care":
			case "experience-clinicalTrial":
			case "experience-community":
			case "experience-financial":
				return groupTheme.experience();
			case "eq5d-5l":
				return groupTheme.qol();
			case "lcss":
				return groupTheme.symptom();
			case "fact-g7":
				return groupTheme.fact();
			case "cost":
				return groupTheme.cost();
			case "start-mr":
				return groupTheme.gi();
			case "clinical":
				return groupTheme.clinical();
			case "prehab":
				return groupTheme.prehab();
			case "sideEffects":
				return groupTheme.sideEffects();
			case "registration_lcn":
				return groupTheme.registration_lcn();
			case "registration_meso":
				return groupTheme.registration_meso();
			case "meso":
				return groupTheme.meso();
			case "mesoperitoneal":
				return groupTheme.mesoperitoneal();
			case "lcn":
			case "lcnuk":
				return groupTheme.lcn();
			default:
				return null;
		}
	};

	const t = getGroupTheme(code) || getGroupTheme(code?.split("-")[0]);
	return t;
};

export const BgColorToTextColorMapFunc = (groupAreaTheme, classPrefix) => {
	if (groupAreaTheme) {
	} else {
		return null;
	}

	const prefix = classPrefix ? `${classPrefix}-` : "";
	const area =
		groupAreaTheme.area.indexOf("registration") === 0
			? "registration"
			: groupAreaTheme.area;

	let ret;

	switch (area) {
		case "primary":
		case "secondary":
			if (groupAreaTheme.group === "lcnuk") {
				ret = `${prefix}white`;
			} else {
				ret = `${prefix}black`;
			}
			break;
		case "symptom":
			if (groupAreaTheme.group === "lcnuk") {
				ret = `${prefix}white`;
				// } else if (groupAreaTheme.group === "meso") {
			} else {
				ret = `${prefix}white`;
			}
			break;

		case "registration":
		case "experience":
		case "qol":
		case "fact":
		case "cost":
		case "gi":
		case "clinical":
		case "prehab":
		case "sideEffects":
			ret = `${prefix}black`;
			break;
		case "setup":
			if (groupAreaTheme.group === "lcnuk") {
				ret = `${prefix}white`;
				// } else if (groupAreaTheme.group === "meso") {
			} else {
				ret = `${prefix}black`;
			}
			break;
		default:
			ret = null;
			break;
	}

	return ret;
};
